import { FlexRow } from '@gorila-shared-ui/components';
import { LabelMedium, ParagraphSmall } from 'baseui/typography';
import { memo } from 'react';
import { useRecoilValue } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { assetState } from '../../../storage/assets';
import { getAssetTitle } from '../../../utils/assets';

type Props = {
  assetId: string;
};

function DeliveryReportTitle({ assetId }: Readonly<Props>) {
  const { theme, classes, css } = useStyles();
  const asset = useRecoilValue(assetState(assetId));

  if (!asset) return null;

  return (
    <FlexRow
      classNames={css({
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
      })}
    >
      <FlexRow
        gap={theme.sizing.scale200}
        classNames={classes.centeredStart}
      >
        <LabelMedium>{getAssetTitle(asset)}</LabelMedium>
        <ParagraphSmall
          margin={0}
          color={theme.colors.contentSecondary}
        >
          ({asset.label})
        </ParagraphSmall>
      </FlexRow>
    </FlexRow>
  );
}

export default memo(DeliveryReportTitle);
